import { defineMessages } from 'react-intl';

export const messages: {
	unknownFieldType: {
		id: string;
		description: string;
		defaultMessage: string;
	};
} = defineMessages({
	unknownFieldType: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.unknown-renderer.unknown-field-type',
		description: 'The message to display for an unknown field type, that is unable to be rendered',
		defaultMessage: "We couldn't load this field at this time.",
	},
});
